.meter {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.pips {
  display: inline-flex;
  gap: 3px;
}

.pip {
  width: 9px;
  height: 14px;
  border-radius: 3px;
  background: var(--panel-3);
}

.on {
  background: var(--q-a);
}

.letter {
  min-width: 1ch;
  color: var(--ink-2);
  font-size: var(--t-dense);
  font-weight: 650;
}
